// extracted by mini-css-extract-plugin
export var accordion = "_fq-0";
export var chevron = "_fq-3";
export var closed = "_fq-2";
export var content = "_fq-4";
export var open = "_fq-1";
export var rotate = "_fq-5";